// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Vælg',
    titleLinkTooltip: 'Gå til side',
    collapseCardTooltip: 'Skjul kortet',
    expandCardTooltip: 'Udvid kortet'
  },
  CardList: {
    loadMore: 'Indlæs mere',
    notFound: 'Ingen ellemter fundet.',
    toolbarSelect: 'Vælg',
    viewCards: 'Kort',
    viewTiles: 'Felter',
    viewList: 'Liste',
    toolbarView: 'Vis'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Afslut',
    cancel: 'Gå tilbage',
    content: 'Er du sikker på, at du vil lukke og afslutte vinduet? Dine dataændringer vil ikke blive gemt.'
  },
  Cuttable: {
    showMore: 'Vis mere',
    showLess: 'Vis mindre'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Annuller'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Annuller'
  },
  Dropdown: {
    close: 'Luk'
  },
  Form: {
    submitButton: 'Gem',
    applyButton: 'Anvend',
    cancelButton: 'Annuller'
  },
  FormField: {
    clear: 'Ryd',
    remove: 'Fjern',
    addMore: 'Tilføj en mere',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Sådan forbedrer du din adgangskode:',
    passwordTooShort: 'Gør adgangskoden længere.',
    lettersLowerCase: 'Brug mindst ét lille bogstav.',
    lettersUpperCase: 'Brug mindst ét stort bogstav.',
    numbers1: 'Brug mindst ét tal.',
    numbers3: 'Brug mindst tre tal.',
    specialChar1: 'Brug mindst ét specialtegn (f. eks.: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Brug mindst to specialtegn (f. eks.: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Brug både store og små bogstaver.',
    comboLettersAndNumbers: 'Brug både tal og bogstaver.',
    comboLettersNumbersSpecial: 'Brug tal, bogstaver og specialtegn.',
    yourPasswordIsStrong: 'Du kan gøre den endnu stærkere ved at øge længden.',
    passwordStrength: 'Adgangskodens styrke er %%strength%%.',
    strengthVeryStrong: 'MEGET STÆRK',
    strengthStrong: 'STÆRK',
    strengthVeryWeak: 'MEGET SVAG',
    strengthWeak: 'SVAG',
    strengthMedium: 'MIDDEL',
    hidePassword: 'Skjul adgangskode',
    showPassword: 'Vis adgangskode',
    generateButton: 'Generer',
    copyButtonHint: 'Kopiér adgangskode',
    copySuccessToast: 'Adgangskode kopieret',
    generateButtonHint: 'Generer en stærk adgangskode'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Kassér ændringer',
    editButtonHint: 'Rediger værdi',
    okButtonHint: 'Gem ændringer'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Vælg fil...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% elementer i alt',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% af %%totalRows%% elementer valgt',
    all: 'Alle',
    allItemsOnPageSelected: 'Alle elementer på siden er valgt',
    allItemsSelected: 'Alle elementer er valgt',
    selectAllItems: 'Vælg alle elementer',
    selectAllItemsOnPage: 'Vælg alle elementer på siden',
    deselectAll: 'Fravælg',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Kunne ikke finde nogen elementer, der matcher filteret',
    emptyTitle: 'Det ser ud til, at der ikke er noget her',
    filteredDescription: 'Afgræns din forespørgsel, eller fjern nogle af kriterierne fra filteret, og prøv igen.'
  },
  ListOperation: {
    cancelButton: 'Annuller'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'af %%total%%',
    itemsPerPage: 'Elementer pr. side',
    all: 'Alle',
    total: 'Side %%current%% af %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Luk',
    cancelButton: 'Annuller'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Intet alternativ',
    placeholder: 'Vælg...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% af %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Luk gruppe'
  },
  Toast: {
    closeButton: 'Close'
  }
};